import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import Home from "./pages/Home.js";
import About from "./pages/About.js";
import Products from "./pages/Products.js";
import Values from "./pages/Values.js";
import Testimonials from "./pages/Testimonials.js";
import Blogs from "./pages/Blogs.js";
import Contact from "./pages/Contact.js";
import PruductDetails from "./pages/ProductPage.js";
import { HelmetProvider } from "react-helmet-async";
import WhatsAppButton from "./components/WhatsAppButton.js";
import ScrollToTop from "./components/ScrollToTop.js";  
import Privacy from "./pages/privacy-policy.js";
import TermsAndConditions from "./pages/TermsOfService.js";
import ReturnAndRefund from "./pages/RefundAndReturns.js";
import WhiteImportedMarble from "./pages/white-imported-marble.js";
import ExoticImportedMarble from "./pages/exotic-imported-marble.js";
import GrayImportedMarble from "./pages/gray-imported-marble.js";
import BeigeImportedMarble from "./pages/beige-imported-marble.js"; 
function App() {
  return (
    <HelmetProvider>
      <div className="app-layout">
        <Navbar />

        <main className="page-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/imported-marble" element={<Products />} />
            <Route path="/values" element={<Values />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/imported-marble/:slug" element={<PruductDetails />} />
            <Route path="/privacy" element={<Privacy/>} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
            <Route path="/return-and-refund" element={<ReturnAndRefund/>} />
            <Route path="/white-imported-marble" element={<WhiteImportedMarble />} />
<Route path="/exotic-imported-marble" element={<ExoticImportedMarble />} />
<Route path="/gray-imported-marble" element={<GrayImportedMarble />} />
<Route path="/beige-imported-marble" element={<BeigeImportedMarble />} />
          </Routes>
        </main>

        <Footer />
        <WhatsAppButton />
        <ScrollToTop />
      </div>
    </HelmetProvider>
  );
}

export default App;
